import { render, staticRenderFns } from "./SimilarCourses.vue?vue&type=template&id=04252ed8"
import script from "./SimilarCourses.vue?vue&type=script&lang=js"
export * from "./SimilarCourses.vue?vue&type=script&lang=js"
import style0 from "./SimilarCourses.vue?vue&type=style&index=0&id=04252ed8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports